<template>
  <div class="payment-container">
    <div class="card-preview" :class="{ flipped: isCvcFocused }">
      <div class="card-front">
        <div class="card-chip"></div>
        <div class="card-number">{{ formattedCardNumber || '#### #### #### ####' }}</div>
        <div class="card-bottom">
          <div class="card-holder">
            <label>Card Holder</label>
            <div class="card-value">{{ cardHolder || 'FULL NAME' }}</div>
          </div>
          <div class="card-expiry">
            <label>Expires</label>
            <div class="card-value">{{ expiryMonth || 'MM' }}/{{ expiryYear || 'YY' }}</div>
          </div>
        </div>
      </div>
      <div class="card-back">
        <div class="card-stripe"></div>
        <div class="card-cvc">
          <label>CVC</label>
          <div class="card-value">{{ cvc || '***' }}</div>
        </div>
      </div>
    </div>

    <form class="payment-form" @submit.prevent="handleSubmit">
      <div class="form-group">
        <label>Card Number</label>
        <input
          type="text"
          v-model="cardNumber"
          @input="formatCardNumber"
          placeholder="4242 4242 4242 4242"
          maxlength="19"
          required
        />
      </div>

      <div class="form-group">
        <label>Card Holder</label>
        <input
          type="text"
          v-model="cardHolder"
          placeholder="John Doe"
          required
        />
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Expiration Date</label>
          <div class="expiry-inputs">
            <select v-model="expiryMonth" required>
              <option value="" disabled>Month</option>
              <option v-for="month in 12" :key="month" :value="String(month).padStart(2, '0')">
                {{ String(month).padStart(2, '0') }}
              </option>
            </select>
            <select v-model="expiryYear" required>
              <option value="" disabled>Year</option>
              <option v-for="year in 10" :key="year" :value="String(new Date().getFullYear() % 100 + year).padStart(2, '0')">
                {{ new Date().getFullYear() % 100 + year }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label>CVC</label>
          <input
            type="password"
            v-model="cvc"
            placeholder="123"
            maxlength="3"
            required
            @focus="isCvcFocused = true"
            @blur="isCvcFocused = false"
          />
        </div>
      </div>

      <button type="submit" class="pay-button">
        Pay ${{ totalAmount }}
      </button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardNumber: '',
      cardHolder: '',
      expiryMonth: '',
      expiryYear: '',
      cvc: '',
      isCvcFocused: false,
      totalAmount: 99.99
    };
  },
  computed: {
    formattedCardNumber() {
      return this.cardNumber.replace(/\s/g, '').replace(/(\d{4})/g, '$1 ').trim();
    }
  },
  methods: {
    formatCardNumber() {
      this.cardNumber = this.cardNumber
        .replace(/\D/g, '')
        .replace(/(\d{4})(\d{4})(\d{4})(\d{0,4})/, '$1 $2 $3 $4')
        .trim();
    },
    handleSubmit() {
      if (this.validateForm()) {
        this.$emit('payment-submitted', {
          number: this.cardNumber.replace(/\s/g, ''),
          holder: this.cardHolder,
          expiry: `${this.expiryMonth}/${this.expiryYear}`,
          cvc: this.cvc
        });
      }
    },
    validateForm() {
      // Add your validation logic here
      return true;
    }
  }
};
</script>

<style scoped>
.payment-container {
  max-width: 500px;
  margin: 2rem auto;
  font-family: 'Arial', sans-serif;
}

.card-preview {
  position: relative;
  height: 220px;
  perspective: 1000px;
  margin-bottom: 2rem;
}

.card-front,
.card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 15px;
  background: linear-gradient(45deg, #2c3e50, #3498db);
  color: white;
  padding: 1.5rem;
  backface-visibility: hidden;
  transition: transform 0.6s;
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.card-back {
  transform: rotateY(180deg);
  background: linear-gradient(45deg, #34495e, #2c3e50);
}

.card-preview.flipped .card-front {
  transform: rotateY(-180deg);
}

.card-preview.flipped .card-back {
  transform: rotateY(0deg);
}

.card-chip {
  width: 50px;
  height: 40px;
  background: linear-gradient(45deg, #f1c40f, #e67e22);
  border-radius: 5px;
  margin-bottom: 1.5rem;
}

.card-number {
  font-size: 1.5rem;
  letter-spacing: 2px;
  margin-bottom: 2rem;
  font-family: 'Courier New', monospace;
}

.card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.card-holder label,
.card-expiry label,
.card-cvc label {
  display: block;
  font-size: 0.7rem;
  opacity: 0.8;
  margin-bottom: 0.3rem;
}

.card-value {
  font-size: 1rem;
  text-transform: uppercase;
}

.card-stripe {
  height: 40px;
  background: #2c3e50;
  margin: 1.5rem -1.5rem;
}

.card-cvc {
  text-align: right;
  margin-top: 1rem;
}

.payment-form {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.form-group {
  margin-bottom: 1.5rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: #2c3e50;
  font-weight: 600;
}

input,
select {
  width: 100%;
  padding: 0.8rem;
  border: 2px solid #ecf0f1;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

input:focus,
select:focus {
  outline: none;
  border-color: #3498db;
}

.expiry-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

select {
  appearance: none;
  background: white url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e") no-repeat right 0.8rem center;
  background-size: 1rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.pay-button {
  width: 100%;
  padding: 1rem;
  background: #27ae60;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
}

.pay-button:hover {
  background: #219a52;
}

@media (max-width: 480px) {
  .card-number {
    font-size: 1.2rem;
  }
  
  .payment-form {
    padding: 1rem;
  }
}
</style>